module.exports = __webpack_public_path__ + "media/images/icons/twotone/notification-887247d6a54909df28b2b197df8a9543.svg";